import React, { useMemo, useReducer } from 'react';
import {
  LISTING,
  SET_LISTING_FILTERS,
  SET_LOADING,
  SET_PAGE,
  SET_PATIENT_NUMBER,
} from './constants';

type PortalPage = 'LISTING' | 'PATIENT';

type NavContextType = {
  page: PortalPage;
  patientNumber: any;
  listingFilters: any;
  loading: boolean;

  dispatch?: any;
};

const initContext = {
  page: LISTING as PortalPage,
  patientNumber: null,
  listingFilters: null,
  loading: false,
};

export const PortalNavContext = React.createContext(
  initContext as NavContextType,
);

export const PortalNavReducer = (
  state: NavContextType,
  action: { type: string; payload: mumms.ComponentName | any },
) => {
  let newState = { ...state };
  switch (action.type) {
    case SET_PAGE:
      newState.page = action.payload;
      break;
    case SET_PATIENT_NUMBER:
      newState.patientNumber = action.payload;
      break;
    case SET_LISTING_FILTERS:
      newState.listingFilters = action.payload;
      break;
    case SET_LOADING:
      newState.loading = action.payload;
      break;
    default:
      newState = state;
      break;
  }
  return newState;
};

export const NavContextProvider = ({ children }: any) => {
  const [
    { page, patientNumber, listingFilters, loading },
    dispatch,
  ] = useReducer(PortalNavReducer, initContext);
  const context = useMemo(
    () => ({
      page,
      patientNumber,
      listingFilters,
      loading,
      dispatch,
    }),
    [page, patientNumber, listingFilters, loading, dispatch],
  );

  return (
    <PortalNavContext.Provider value={context}>
      {children}
    </PortalNavContext.Provider>
  );
};
